import styled from "styled-components";
import { colors } from "../../../../../styles/colors";

export const BodyContainer = styled.div`
  margin-bottom: 30px;

  .separator {
    height: 0.5px;
    background-color: ${colors.lightBlueGray};
    margin: 12px 0;
  }
`;
